import React, { useEffect } from 'react';
import { object, func, bool, string } from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import { Translation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';
import queryString from 'query-string';

const styles = (theme) => ({
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: 0,
  },
  button: {
    marginTop: theme.spacing(2),
    backgroundColor: '#357a38',
    color: '#ffffff',
    fontWeight: '600',
  },
  linkButton: {
    marginTop: theme.spacing(2),
  },
  progress: {
    flexGrow: 1,
  },
  root: {},
  headerContainer: {},
  titleStyle: {},
  subTitle: {},
  itemMidContainer: {},
  footerContainer: {},
  footerBar: {},
  textFooterTerms: {},
  textFooter: {},
  trademarkText: {},
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

function RequestResetPassword(props) {
  const {
    password,
    passwordError,
    confirmPassword,
    confirmPasswordError,
    isFetching,
    canReset,
    error = '',
    classes,
    isReset,
    location,
    setNewPassword,
    passwordChanged,
    confirmPasswordChanged,
    resetState,
  } = props;

  useEffect(() => {
    resetState();
  }, [resetState]);

  function onSubmit(event) {
    event.preventDefault();
    const values = queryString.parse(location.search);
    setNewPassword(values.key, password);
  }

  function onPasswordChange(event) {
    passwordChanged(event.target.value);
  }

  function onConfirmPasswordChange(event) {
    confirmPasswordChanged(event.target.value);
  }

  return (
    <Translation>
      {(t) => {
        if (isReset) {
          return (
            <Grid container alignItems="center" justifyContent="space-around">
              <Grid item xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                  {t('passwordResetConfirmation')}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button
                  variant="contained"
                  color="primary"
                  component={Link}
                  to="/login"
                  className={classes.button}
                >
                  {t('ok')}
                </Button>
              </Grid>
            </Grid>
          );
        }
        return (
          <form onSubmit={onSubmit}>
            {isFetching && <LinearProgress className={classes.progress} />}
            {error.length > 0 && (
              <Typography variant="body1" color="error" gutterBottom>
                {error}
              </Typography>
            )}
            <TextField
              id="password"
              name="password"
              type="password"
              label={t('password')}
              value={password}
              onChange={onPasswordChange}
              className={classes.textField}
              fullWidth
              error={passwordError.length > 0}
              disabled={isFetching}
            />
            <TextField
              id="confirm-password"
              label={t('confimPassword')}
              type="password"
              value={confirmPassword}
              onChange={onConfirmPasswordChange}
              className={classes.textField}
              fullWidth
              error={confirmPasswordError.length > 0}
              disabled={isFetching}
            />
            <MuiThemeProvider theme={theme}>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                className={classes.button}
                fullWidth
                disabled={isFetching || !canReset}
              >
                {t('resetPassword')}
              </Button>
            </MuiThemeProvider>
          </form>
        );
      }}
    </Translation>
  );
}

RequestResetPassword.propTypes = {
  classes: object.isRequired,
  password: string.isRequired,
  confirmPassword: string.isRequired,
  isFetching: bool.isRequired,
  passwordError: string,
  confirmPasswordError: string,
  error: string,
  passwordChanged: func.isRequired,
  confirmPasswordChanged: func.isRequired,
  canReset: bool.isRequired,
  setNewPassword: func.isRequired,
  isReset: bool.isRequired,
  resetState: func.isRequired,
};

RequestResetPassword.defaultProps = {
  password: '',
  confirmPassword: '',
  error: '',
};

export default withStyles(styles)(RequestResetPassword);



// WEBPACK FOOTER //
// ./src/view/forms/ResetPassword/ResetPassword.js